var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeletebutton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H19.3333H30",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4154 20.0002C29.4154 19.5859 29.0796 19.2502 28.6654 19.2502C28.2512 19.2502 27.9154 19.5859 27.9154 20.0002H29.4154ZM20.082 20.0002C20.082 19.5859 19.7462 19.2502 19.332 19.2502C18.9178 19.2502 18.582 19.5859 18.582 20.0002H20.082ZM20.582 20.0002C20.582 20.4144 20.9178 20.7502 21.332 20.7502C21.7462 20.7502 22.082 20.4144 22.082 20.0002H20.582ZM25.9154 20.0002C25.9154 20.4144 26.2512 20.7502 26.6654 20.7502C27.0796 20.7502 27.4154 20.4144 27.4154 20.0002H25.9154ZM27.9154 20.0002V29.3335H29.4154V20.0002H27.9154ZM27.9154 29.3335C27.9154 29.6557 27.6542 29.9168 27.332 29.9168V31.4168C28.4826 31.4168 29.4154 30.4841 29.4154 29.3335H27.9154ZM27.332 29.9168H20.6654V31.4168H27.332V29.9168ZM20.6654 29.9168C20.3432 29.9168 20.082 29.6557 20.082 29.3335H18.582C18.582 30.4841 19.5148 31.4168 20.6654 31.4168V29.9168ZM20.082 29.3335V20.0002H18.582V29.3335H20.082ZM22.082 20.0002V18.6668H20.582V20.0002H22.082ZM22.082 18.6668C22.082 18.3447 22.3432 18.0835 22.6654 18.0835V16.5835C21.5148 16.5835 20.582 17.5162 20.582 18.6668H22.082ZM22.6654 18.0835H25.332V16.5835H22.6654V18.0835ZM25.332 18.0835C25.6542 18.0835 25.9154 18.3447 25.9154 18.6668H27.4154C27.4154 17.5162 26.4826 16.5835 25.332 16.5835V18.0835ZM25.9154 18.6668V20.0002H27.4154V18.6668H25.9154Z",
    fill: "#7B8794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 23.3335V27.3335",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.332 23.3335V27.3335",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 47.5,
    rx: 23.75,
    stroke: "#323F4B",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletebutton);
export default __webpack_public_path__ + "static/media/Delete button.4169d3e889fd57aae6648f87c4548d5d.svg";
export { ForwardRef as ReactComponent };